import http from "../http-common";
import { Template } from "../models/templateModel";

class TemplateDataService{
    async createTemplate(template: Template) {
        const json = JSON.stringify(template);
        return await http.post("/template/create", json);
      }
}

export default new TemplateDataService();